import React from 'react';
// opting out of our components Switch because it forces a label wrapper which frustrates the design here.
import { Switch as AntdSwitch } from 'antd';
import styled from 'styled-components';
import { Icon, Tooltip } from 'components';
import { ContentWrapper, ContentSpace } from './styledComponents';

import { AnsweringServiceActiveContent } from './AnsweringServiceActiveContent';
import { AnsweringServiceInactiveContent } from './AnsweringServiceInactiveContent';

type AnsweringServiceSettingsProps = {
  useAppointmentDesk?: boolean;
  onToggleUseAppointmentDesk: () => void;
  answeringServicePhone?: string;
};

export const AnsweringServiceSettings = (
  props: AnsweringServiceSettingsProps,
) => {
  const {
    onToggleUseAppointmentDesk,
    useAppointmentDesk,
    answeringServicePhone,
  } = props;

  return (
    <ContentWrapper>
      <ContentSpace size="middle" direction="vertical">
        <StyledSwitchWrapper>
          <Tooltip title={`Click to turn ${useAppointmentDesk ? 'off' : 'on'}`}>
            <AntdSwitch
              checkedChildren={
                <Icon type="antdCheckOutlined" width={12} color="white" />
              }
              unCheckedChildren={
                <Icon type="antdCloseOutlined" width={12} color="white" />
              }
              checked={useAppointmentDesk}
              onClick={onToggleUseAppointmentDesk}
            />
          </Tooltip>
        </StyledSwitchWrapper>

        {useAppointmentDesk ? (
          <AnsweringServiceActiveContent
            answeringServicePhone={answeringServicePhone}
          />
        ) : (
          <AnsweringServiceInactiveContent />
        )}
      </ContentSpace>
    </ContentWrapper>
  );
};

const StyledSwitchWrapper = styled.div`
  .ant-switch-inner {
    padding-bottom: 2px;
  }
`;
